import { StatusBadge, resolveInvoiceStatusColor } from "../ui/status-badge";
import type { InvoiceStatus, InvoiceStatusValue } from "./types";

const PRESET: Record<InvoiceStatus, { label: string; color: string }> = {
  paid: { label: "Paid", color: "green" },
  pending: { label: "Pending", color: "yellow" },
  overdue: { label: "Overdue", color: "red" },
  draft: { label: "Draft", color: "gray" },
};

interface Props {
  status: InvoiceStatusValue;
}

export function InvoiceStatusBadge({ status }: Props) {
  if (typeof status === "string") {
    const preset = PRESET[status];
    return <StatusBadge label={preset.label} color={preset.color} />;
  }
  const color = resolveInvoiceStatusColor(null, status.color);
  return <StatusBadge label={status.label} color={color} />;
}
